import { graphqlClient } from "../../../client";
import getMyAddressesQueryDocument from "./getMyAddressesQuery.graphql";
import type { ContactTypeExtensionAddressesArgs, MemberAddressTypeExtension, Query } from "@/core/api/graphql/types";

export async function getMyAddresses(
  payload?: ContactTypeExtensionAddressesArgs,
): Promise<MemberAddressTypeExtension[]> {
  const { data } = await graphqlClient.query<Required<Pick<Query, "me">>, ContactTypeExtensionAddressesArgs>({
    query: getMyAddressesQueryDocument,
    variables: {
      first: 1000,
      ...payload,
    },
  });

  return data.me.contact?.addresses?.items ?? [];
}
